import { colors } from '@lmc/common/constants'
import type { CSSProperties } from 'react'
import styled from 'styled-components'

type BadgeColor =
  | 'active'
  | 'cancelled'
  | 'default'
  | 'delete'
  | 'inactive'
  | 'primary'
  | 'secondary'

interface BadgeProps {
  color?: BadgeColor
  label?: string
  style?: CSSProperties
}

const colorStyles: Record<BadgeColor, { background: string; color: string }> = {
  active: { background: colors.green, color: 'white' },
  cancelled: { background: colors.orange, color: 'white' },
  default: { background: colors.grey, color: 'black' },
  delete: { background: colors.red, color: 'white' },
  inactive: { background: colors.grey, color: 'black' },
  primary: { background: colors.pink, color: 'white' },
  secondary: { background: colors.grey, color: 'black' }
}

const StyledBadge = styled.span`
  border: none;
  border-radius: 60px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-left: 5px;
  padding: 3px 12px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out;
  vertical-align: middle;

  &:focus {
    outline: 0;
  }
`

export default function Badge({ color = 'default', label, style }: BadgeProps) {
  const colorStyle = colorStyles[color]
  return <StyledBadge style={{ ...style, ...colorStyle }}>{label}</StyledBadge>
}
